import React, { useEffect } from 'react';
import { Button, Text } from '@certilogo/design-system';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { flowRequest } from 'containers/Warranty/actions';
import { setBack } from 'containers/App/actions';
import Stepper from '@certilogo/design-system/dist/components/Stepper';
import history from 'utils/history';
import { get, map } from 'lodash';
import ViewInput from '@certilogo/design-system/dist/components/ViewInput';
import { format, parseISO } from 'date-fns';
import messages from './messages';

const Recap = ({ colorType, authenticationId, data }) => {
  const {
    authentication,
    data: { page, userData, productData },
    props: { userFields, productFields },
  } = data;
  const dispatch = useDispatch();

  useEffect(() => {
    if (data) {
      dispatch(
        setBack({
          back: flowRequest({
            action: 'prev',
            authenticationId,
            page,
          }),
        }),
      );
    }
  }, [authenticationId]);

  const handleSubmit = () => {
    dispatch(flowRequest({ action: 'next', authenticationId, page }));
  };

  const handleEdit = () => {
    dispatch(
      flowRequest({
        action: 'edit',
        authenticationId,
        page,
      }),
    );
  };

  return (
    <>
      <Stepper totalSteps={3} actualStep={3} colorType={colorType} />

      <Text weight="extrabold" colorType={colorType} marginTop="l" marginBottom="m">
        <FormattedMessage {...messages.formTitle} />
      </Text>

      <ViewInput.BoxWrapper colorType={colorType}>
        {map(userFields, ({ label, name }) => (
          <ViewInput
            colorType={colorType}
            label={<FormattedMessage id={label} defaultMessage={label} />}
          >
            {get(userData, name)}
          </ViewInput>
        ))}
      </ViewInput.BoxWrapper>

      <ViewInput.BoxWrapper colorType={colorType}>
        {map(productFields, ({ label, name }) => (
          <ViewInput
            colorType={colorType}
            label={<FormattedMessage id={label} defaultMessage={label} />}
          >
            {get(productData, name)}
          </ViewInput>
        ))}
      </ViewInput.BoxWrapper>

      <ViewInput.BoxWrapper colorType={colorType}>
        <ViewInput colorType={colorType} label={<FormattedMessage {...messages.certilogoCode} />}>
          {authentication?.certilogoCode}
        </ViewInput>
        <ViewInput colorType={colorType} label={<FormattedMessage {...messages.response} />}>
          {authentication?.response}
        </ViewInput>
        <ViewInput colorType={colorType} label={<FormattedMessage {...messages.brand} />}>
          {authentication?.primaryBrand.name}
        </ViewInput>
        <ViewInput colorType={colorType} label={<FormattedMessage {...messages.salesChannel} />}>
          {authentication?.bought}
        </ViewInput>
        <ViewInput
          colorType={colorType}
          label={<FormattedMessage {...messages.authenticationDate} />}
        >
          {authentication?.dateCreated &&
            format(parseISO(authentication?.dateCreated), 'dd/MM/yyyy')}
        </ViewInput>
      </ViewInput.BoxWrapper>

      <Button type="submit" colorType={colorType} onClick={handleSubmit} noMargin>
        <FormattedMessage {...messages.buttonSubmit} />
      </Button>
      <Button
        type="button"
        buttonType="link"
        colorType={colorType}
        onClick={handleEdit}
        arrow={false}
        noMargin
      >
        <FormattedMessage {...messages.buttonEdit} />
      </Button>
      <Button
        type="button"
        buttonType="link"
        colorType={colorType}
        onClick={() => history.push(`/authentication/${authenticationId}`)}
        arrow={false}
        noMargin
      >
        <FormattedMessage {...messages.buttonSave} />
      </Button>
    </>
  );
};

Recap.propTypes = {
  colorType: PropTypes.string,
  authenticationId: PropTypes.string,
  data: PropTypes.shape({
    authentication: PropTypes.object,
    data: PropTypes.object,
    props: PropTypes.object,
  }),
};

export default Recap;
